import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CityService {
  
  private apiUrl = `${environment.apiUrl}/cities`;

  constructor(private http: HttpClient) { }

  getList(){
    return this.http.get(this.apiUrl)
  }
}
